import { createSafeContext } from '@mews/framework';
import { WithEnterpriseIds } from '../../../../../types';

export const { SelectedEnterpriseIdsContextProvider, useSelectedEnterpriseIdsContext } = createSafeContext<
    'SelectedEnterpriseIdsContext',
    WithEnterpriseIds
>('SelectedEnterpriseIdsContext');
